import { Widget } from '../../widget/widget';
import {
  QuestionsRightAnswersWidgetComponent,
  QuestionsRatioAnswersWidgetComponent,
  QuestionsCreatedWidgetComponent
} from '../../widget/widgets';

export const QuestionsRightAnswersWidget = (groupId) => {
  return new Widget(QuestionsRightAnswersWidgetComponent, {
    id: `widget-right-answers-${groupId}`,
    name: `widget-right-answers-${groupId}`,
    groupId
  });
};

export const QuestionsRatioAnswersWidget = (groupId) => {
  return new Widget(QuestionsRatioAnswersWidgetComponent, {
    id: `widget-ratio-answers-${groupId}`,
    name: `widget-ratio-answers-${groupId}`,
    groupId
  });
};

export const QuestionsCreatedWidget = (groupId) => {
  return new Widget(QuestionsCreatedWidgetComponent, {
    id: `widget-created-questions-${groupId}`,
    name: `widget-created-questions-${groupId}`,
    groupId
  });
};
